var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        value: _vm.showMenu,
        "position-x": _vm.x,
        "position-y": _vm.y,
        absolute: "",
        "offset-y": ""
      }
    },
    [
      _c(
        "v-list",
        { attrs: { dense: "" } },
        [
          _c(
            "v-list-item",
            {
              on: {
                click: function($event) {
                  return _vm.activateAction("edit", "ductEntryForm")
                }
              }
            },
            [_c("v-list-item-title", [_vm._v(_vm._s(_vm.$t("Edit")))])],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item",
            {
              on: {
                click: function($event) {
                  return _vm.activateAction("resize", "ductEntryTypeSelector")
                }
              }
            },
            [_c("v-list-item-title", [_vm._v(_vm._s(_vm.$t("ChangeType")))])],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item",
            {
              on: {
                click: function($event) {
                  return _vm.activateAction("move", "ductEntryAction")
                }
              }
            },
            [_c("v-list-item-title", [_vm._v(_vm._s(_vm.$t("Move")))])],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item",
            {
              on: {
                click: function($event) {
                  return _vm.activateAction("clone", "ductEntryAction")
                }
              }
            },
            [_c("v-list-item-title", [_vm._v(_vm._s(_vm.$t("Clone")))])],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item",
            { on: { click: _vm.remove } },
            [_c("v-list-item-title", [_vm._v(_vm._s(_vm.$t("Delete")))])],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-053250a1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-053250a1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Masks/Duct/DuctEntryMenu.vue
// module id = null
// module chunks = 